import { HTMLAttributes } from 'react';
import { CTAButtonTypes } from '../../../../components/ctaButton/CTAButtonTypes';
import { ClickableTextTypes } from '../../../../components/clickableText/ClickableTextTypes';

export namespace LocationInfoTypes {
  export interface ILocationInfo extends HTMLAttributes<HTMLDivElement> {
    theme: string;
    variant: 'layout50x50' | 'layout70x30';
    showLocationName: boolean;
    locationDetails: TLocation[];
  }

  export type TLocation = {
    name?: string;
    address?: string;
    email?: string;
    phoneNumber?: string;
    googleMapsUrl?: string;
    mailingAddress?: string;
    iFrameUrl?: string;
    amenities?: TAmenities;
    otherInfo?: TOtherInfo[];
    ctaConfig?: TButton[];
  };

  export type TMap = {
    iFrameUrl: string;
  };
  export type TOfficeAddressAndHours = {
    name?: string;
    address?: string;
    email?: string;
    phoneNumber?: string;
    googleMapsUrl?: string;
    mailingAddress?: string;
    otherInfo?: TOtherInfo[];
  };
  export type TKeyValuePairs = {
    data: TOtherInfo[];
  };
  export type TAmenities = {
    title?: string;
    description?: string;
    list: string[];
  };

  export type TOtherInfo = {
    title?: string;
    list: TList[];
  };
  export type TList = {
    key?: string;
    value?: string;
    type?: ClickableTextTypes.TLinkType;
    url?: string;
  };
  export type TButton = {
    type: 'primary' | 'outline' | 'tertiary';
    link: string;
    label: string;
    icon?: CTAButtonTypes.TCTAIcon;
    theme?: 'light' | 'dark' | 'highlighted';
  };
}
